import { Tooltip } from "react-tooltip";
import Button from "shared/components/Button";
import { ReactComponent as ViewButtonSVG } from "assets/icons/view.svg";
import { DELAY_SHOW } from "shared/helpers/reactTooltip";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { setTopDownView } from "features/krpano/details-slice";

interface ViewButtonProps {}

const ViewButton: React.FC<ViewButtonProps> = () => {
  const topDownView = useAppSelector((state) => state.krpano.topDownView);
  const dispatch = useAppDispatch();
  return (
    <div data-tooltip-id="KEY_BUTTON_VIEW">
      <Button
        colour="Theme"
        additionalClassNames={`PrimaryButton SVGButton ${
          topDownView ? "Active" : ""
        } NoBorder`}
        disabledClass="DisabledOpacity"
        onClick={() => {
          dispatch(setTopDownView(!topDownView));
        }}
        children={
          <ViewButtonSVG
            height={20}
            width={20}
            role="button"
            aria-label="Change view"
          />
        }
      />
      <Tooltip
        id="KEY_BUTTON_VIEW"
        place="top"
        className="ToolTip"
        delayShow={DELAY_SHOW}
        children="View"
      />
    </div>
  );
};

export default ViewButton;
